var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPriorityOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C11.45 21 10.9793 20.8043 10.588 20.413C10.196 20.021 10 19.55 10 19C10 18.45 10.196 17.979 10.588 17.587C10.9793 17.1957 11.45 17 12 17C12.55 17 13.021 17.1957 13.413 17.587C13.8043 17.979 14 18.45 14 19C14 19.55 13.8043 20.021 13.413 20.413C13.021 20.8043 12.55 21 12 21ZM12 15C11.45 15 10.9793 14.804 10.588 14.412C10.196 14.0207 10 13.55 10 13V5C10 4.45 10.196 3.979 10.588 3.587C10.9793 3.19567 11.45 3 12 3C12.55 3 13.021 3.19567 13.413 3.587C13.8043 3.979 14 4.45 14 5V13C14 13.55 13.8043 14.0207 13.413 14.412C13.021 14.804 12.55 15 12 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPriorityOutline);
export default __webpack_public_path__ + "static/media/ico-priority-outline.3a9d2ca534db1d9b67c4b16d835ec889.svg";
export { ForwardRef as ReactComponent };